import axios from '@/libs/api.request';

export const getPreSaleOrderWarehouseProductStore = data => {
    return axios.request({
        url: 'api/warehouseManagement/warehouseStore/getPreSaleOrderWarehouseProductStore',
        data: data,
        method: 'post'
    });
};

export const getCurSaleOrderWarehouseProductStore = data => {
    return axios.request({
        url: 'api/warehouseManagement/warehouseStore/getCurSaleOrderWarehouseProductStore',
        data: data,
        method: 'post'
    });
};

